import axios from "axios"

const BASE_URL = process.env.REACT_APP_API_URL


class CreatorApi {
  getCreatorDetails(userId, config) {
    return axios.get(BASE_URL + "/admin/creator/bank-details/" + userId, config)
  }
}

const creatorApi = new CreatorApi()
export default creatorApi
